import { useEffect, useRef } from 'react';

import useIntersectionObserver from 'src/hooks/use-intersection-observer';

interface UseCatalogScrollingParams {
  category: string;
  setActiveCategory: (category: string) => void;
  setCategoryRef: (category: string, element: HTMLDivElement) => void;
}

export default function useCatalogScrolling({
  category,
  setActiveCategory,
  setCategoryRef,
}: UseCatalogScrollingParams) {
  const ref = useRef<HTMLDivElement | null>(null);

  const entry = useIntersectionObserver(ref, {
    rootMargin: '-50% 0%',
  });

  useEffect(() => {
    if (entry?.isIntersecting) {
      setActiveCategory(category);
    }
  }, [category, entry?.isIntersecting, setActiveCategory]);

  useEffect(() => {
    if (ref.current) {
      setCategoryRef(category, ref.current);
    }
  }, [category, setCategoryRef]);

  return ref;
}
